import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.5092 26.5518H60.5013V67.3713H35.5092V26.5518Z",
			fill: "#FF5F00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.0835 46.965C38.0804 43.0345 38.9714 39.1547 40.6892 35.6193C42.4069 32.084 44.9062 28.9857 47.9982 26.5589C44.1687 23.5493 39.5697 21.6778 34.727 21.1583C29.8842 20.6389 24.9929 21.4923 20.6123 23.6212C16.2316 25.75 12.5382 29.0684 9.95424 33.197C7.37028 37.3257 6 42.098 6 46.9686C6 51.8391 7.37028 56.6114 9.95424 60.7401C12.5382 64.8687 16.2316 68.1871 20.6123 70.3159C24.9929 72.4448 29.8842 73.2983 34.727 72.7788C39.5697 72.2593 44.1687 70.3878 47.9982 67.3782C44.9053 64.9507 42.4053 61.8512 40.6876 58.3145C38.9698 54.7778 38.0793 50.8967 38.0835 46.9649V46.965Z",
			fill: "#EB001B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M87.5195 63.0518V62.2155H87.8801V62.0424H87.0221V62.2155H87.361V63.0519L87.5195 63.0518ZM89.1852 63.0518V62.0425H88.9256L88.6228 62.7634L88.3199 62.0424H88.0604V63.0518H88.2478V62.2875L88.5291 62.9438H88.7237L89.005 62.2875V63.0518H89.1852Z",
			fill: "#F79E1B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 46.965C89.9998 51.836 88.6292 56.6086 86.0448 60.7374C83.4604 64.8662 79.7664 68.1845 75.3852 70.313C71.004 72.4416 66.1122 73.2945 61.2691 72.7742C56.4261 72.254 51.8271 70.3816 47.9979 67.3711C51.0886 64.9421 53.5872 61.8429 55.3054 58.3074C57.0236 54.7719 57.9163 50.8923 57.9163 46.9614C57.9163 43.0305 57.0236 39.1509 55.3054 35.6153C53.5872 32.0798 51.0886 28.9806 47.9979 26.5517C51.8271 23.5411 56.4261 21.6687 61.2692 21.1485C66.1123 20.6283 71.004 21.4812 75.3853 23.6097C79.7665 25.7383 83.4605 29.0566 86.0449 33.1854C88.6293 37.3142 89.9999 42.0869 90 46.9578V46.965Z",
			fill: "#F79E1B"
		})
	]
});
export default SvgMastercard;
